import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";
import {setLocalStorage, getLocalStorage} from "@js/helpers.ts";
import {useMenuStore} from "@js/store/MenuStore.js";
import axios from 'axios';
import {checkDocument} from "@js/helpers.ts";

const getCompareIdsFromCookie = () => {
    if (!checkDocument()) return []

    const likes = getLocalStorage('comparedIds');
    if (likes) {
        try {
            return JSON.parse(likes);
        } catch (e) {
            console.error('Не удалось распарсить likedIds из cookie', e);
            return [];
        }
    }

    return [];
}

export const useCompareStore = defineStore('compareStore', {
    state: () => ({
        comparedIds: getCompareIdsFromCookie(),
        comparing_data: { characteristics: {}, data: {} },
        loading_products: true,
    }),
    actions: {
        getCompares() {
            if (!checkDocument()) return []

            const compares = getLocalStorage('comparedIds');
            if (compares) {
                try {
                    this.comparedIds = JSON.parse(compares);
                } catch (e) {
                    console.error('Не удалось распарсить comparedIds из cookie', e);
                    this.comparedIds = [];
                }
            }
            return this.comparedIds;
        },
        toggleCompare(productId) {
            const themeStore = useThemeStore();

            if (this.isCompared(productId)) {
                this.comparedIds = this.comparedIds.filter(id => id !== productId);
                themeStore.addToast("Убрано из сравнения", "success");
            } else {
                this.comparedIds.push(productId);
                themeStore.addToast("Добавлено к сравнению", "success", {
                    route_name: 'compareProducts',
                }, 5000);

                const menuStore = useMenuStore();
                menuStore.triggerCatalogButtonPing?.('bg-blue-500');
            }

            setLocalStorage('comparedIds', JSON.stringify(this.comparedIds), 525600); // на год
        },
        isCompared(productId) {
            return this.comparedIds.includes(productId);
        },
        getComparedProductsData() {
            if (this.comparedIds.length) {
                this.loading_products = true;
                axios.post('/axios/products/get-comparison-data', {
                    ids: this.comparedIds,
                })
                    .then(response => {
                        this.comparing_data = response.data ?? { characteristics: {}, data: {} };
                    })
                    .catch(() => {
                        this.comparing_data = { characteristics: {}, data: {} };
                    })
                    .finally(() => {
                        this.loading_products = false;
                    });
            } else {
                this.comparing_data = { characteristics: {}, data: {} };
                this.loading_products = false;
            }
        },
    },
});
